import { Injectable } from "@angular/core";
import { ServiceType } from "./models/service/servicetype.model";

@Injectable()
export class TransactionType{
  constructor(){
    
  }
  getListTransactionType():ServiceType[]{
    let TransactionTypeList:ServiceType[]=[];
    TransactionTypeList.push( new ServiceType(1, 'Nạp tiền'));
    TransactionTypeList.push( new ServiceType(2, 'Bán hàng'));
    TransactionTypeList.push( new ServiceType(3, 'Chuyển tiền'));
    TransactionTypeList.push( new ServiceType(4, 'Hủy'));
    TransactionTypeList.push( new ServiceType(5, 'Hoàn tiền'));
    TransactionTypeList.push( new ServiceType(6, 'Rút tiền'));
    return TransactionTypeList;
  }
}
